/**
 * The optional web link on a List section's resource ("YouTube Kids: …"),
 * typed in the edit/add forms. The link isn't shown on the rows; students
 * just get a clickable row (LessonView ListSection).
 */
import React from 'react';
import { Link2 } from 'lucide-react';
import { isInvalidLink } from '../../../lib/resourceLink';

export function ResourceLinkField({ value, onChange, testId }) {
  const invalid = isInvalidLink(value);
  return (
    <div>
      <div className={`flex items-center gap-2 px-3 py-2 rounded-lg border bg-white ${invalid ? 'border-red-300' : 'border-[#34A853]/20'}`}>
        <Link2 className="w-3.5 h-3.5 text-slate-400 flex-shrink-0" />
        <input type="url" inputMode="url" value={value || ''} onChange={e => onChange(e.target.value)}
          placeholder="Link (optional) — e.g. https://www.youtube.com/watch?v=…"
          className="flex-1 min-w-0 text-xs bg-transparent focus:outline-none"
          onClick={e => e.stopPropagation()} onMouseDown={e => e.stopPropagation()}
          aria-invalid={invalid} data-testid={testId} />
      </div>
      {invalid && <p className="text-xs text-red-500 mt-1">Enter a web link starting with https:// (or leave it empty).</p>}
    </div>
  );
}
